import React, { Fragment } from "react";
import Header from "../components/Header";
import Leftnav from "../components/Leftnav";
import Appfooter from "../components/Appfooter";
import { useTranslation } from "react-i18next";

const Privacy = () => {
  const { t } = useTranslation("legal");
  const date = "2025-10-13";

  return (
    <Fragment>
      <Header />
      <Leftnav />
      <div className="main-content right-chat-active">
        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left">
            <div className="card w-100 border-0 bg-white shadow-xs p-4 mb-4 rounded-xxl">
              <h2 className="fw-700 mb-3">{t("privacy.title")}</h2>
              <p className="text-grey-700">{t("common.updated", { date })}</p>

              <h4 className="fw-700 mt-4">{t("privacy.s1t")}</h4>
              <ul>{t("privacy.s1l", { returnObjects: true }).map((x, i) => <li key={i}>{x}</li>)}</ul>

              <h4 className="fw-700 mt-4">{t("privacy.s2t")}</h4>
              <ul>{t("privacy.s2l", { returnObjects: true }).map((x, i) => <li key={i}>{x}</li>)}</ul>

              <h4 className="fw-700 mt-4">{t("privacy.s3t")}</h4>
              <p>{t("privacy.s3d")}</p>

              <h4 className="fw-700 mt-4">{t("privacy.s4t")}</h4>
              <p>{t("privacy.s4d")}</p>

              <h4 className="fw-700 mt-4">{t("privacy.s5t")}</h4>
              <p>{t("privacy.s5d")}</p>

              <h4 className="fw-700 mt-4">{t("privacy.s6t")}</h4>
              <p>{t("privacy.s6d")}</p>

              <h4 className="fw-700 mt-4">{t("privacy.s7t")}</h4>
              <p>{t("privacy.s7d")}</p>

              <h4 className="fw-700 mt-4">{t("privacy.s8t")}</h4>
              <p>{t("privacy.s8d")}</p>

              <h4 className="fw-700 mt-4">{t("privacy.s9t")}</h4>
              <p>{t("privacy.s9d", { email: t("common.email") })}</p>
            </div>
          </div>
        </div>
      </div>
      <Appfooter />
    </Fragment>
  );
};

export default Privacy;
